import React from 'react';
import ReactDOM from 'react-dom/client';
import DockerRegistryViewer from './components/DockerRegistryViewer';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <DockerRegistryViewer />
  </React.StrictMode>
);
